import { faChartLine } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import KeyboardArrowLeftIcon from "@mui/icons-material/KeyboardArrowLeft";
import KeyboardArrowRightIcon from "@mui/icons-material/KeyboardArrowRight";
import { BiCar, BiWallet } from 'react-icons/bi';
import { FiUsers } from 'react-icons/fi';
import { MdKeyboardArrowDown } from 'react-icons/md';
import LogoutIcon from "@mui/icons-material/Logout";
import { Grid } from "@mui/material";
import React, { ReactElement, memo, useEffect, useState } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { setIsOpen } from "../../actions/modalActions";
import logo_collapsed from "../../assets/images/yassir-logo_collapsed.png";
import logo_collapsed_ar from "../../assets/images/yassir-logo_collapsed_ar.png";
import logo from "../../assets/images/yassir-new-logo.png";
import logo_ar from "../../assets/images/yassir-new-logo-ar.png";
import LogoutModal from "../LogoutModalComponent";
import { useStyles } from "./styles";
import { AppState } from "../../reducers";

interface IFormProps {
  isCollapsed: any;
}

const Sidebar: React.FC<IFormProps> = ({ isCollapsed }): ReactElement => {

  const { t } = useTranslation();

  const [show, setShow] = useState<boolean>(false)

  const navigate = useNavigate();

  const classes = useStyles();

  const dispatch = useDispatch();

  const [collapsed, setCollapsed] = useState(false);

  const [press, setPress] = useState(false);

  const { intl } = useSelector((state: AppState) => state.intl);

  const params = useParams();

  const [loggo, setLoggo] = useState<any>();

  const [loggoColapse, setLoggoColapse] = useState<any>();

  const handleOpen = () => {
    dispatch(setIsOpen(true));
  };

  const toggleMenu = () => {
    setCollapsed(!collapsed);
    setPress(true)
  };

  useEffect(() => {
    if (press) isCollapsed(collapsed);
  }, [isCollapsed, collapsed, press]);

  // useEffect(() => {
  //   setCollapsed(closeSideBar);
  // }, [closeSideBar]);

  const toggle = (val: boolean) => {
    setShow(val);
  }

  useEffect(() => {
    if (['/paiements', '/revenues'].includes(window.location.pathname)) setShow(true)
  }, []);

  useEffect(() => {
    switch (String(intl)) {
      case 'ar':
        setLoggo(logo_ar);
        setLoggoColapse(logo_collapsed_ar);
        break;
      default:
        setLoggo(logo);
        setLoggoColapse(logo_collapsed);
        break;
    }
  }, [intl]);

  return (
    <>
      <LogoutModal />
      <Grid
        xs={12} md={12} lg={12}
        className={collapsed ? classes.collapsed_sidebar : classes.sidebar}
      >
        <Grid item xs={12} className={classes.logo_container} data-testid="side-menu-item-logo">
          <img className={classes.logoWeb} src={collapsed ? loggoColapse : loggo} alt="yassir" data-testid="logo-image" />
          <img className={classes.logoMob} src={loggoColapse} alt="yassir" data-testid="logo-image" />
        </Grid>
        <Grid
          item
          xs={12}
          style={{ flexDirection: "column" }}
          className={
            collapsed
              ? classes.collapsed_menu_container
              : classes.menu_container
          }
        >
          <Grid
            onClick={() => { toggle(false); navigate('/performance') }}
            style={{
              padding: '30px 0px 30px 17px',
              backgroundColor: window.location.pathname === '/performance' ? '#35087C' : 'transparent',
            }}
            item
            data-testid="side-menu-item-performance"
            xs={12}
            className={
              collapsed
                ? classes.collapsed_active_menu_item
                : classes.active_menu_item
            }
          >
            <Link className={classes.linkSidebar} to={"/performance"}>
              <div className={classes.divCtn} style={{ padding: intl === 'ar' ? '18px 15px 16px 0px' : '18px 0px 16px 15px', width: collapsed ? 'auto' : '87%' }}>
                <FontAwesomeIcon icon={faChartLine} className={intl === 'ar' ? classes.iconLinkRight : classes.iconLink} />
                {!collapsed && <span className={intl === 'ar' ? classes.txtSidebarRight : classes.txtSidebar}>{t("performance")}</span>}
              </div>
            </Link>
          </Grid>
          <div style={{ height: '10px' }} />
          <Grid
            onClick={() => { toggle(false); navigate('/chauffeurs') }}
            style={{
              padding: '30px 0px 30px 17px',
              backgroundColor: params?.type === 'driver' || window.location.pathname === '/chauffeurs' ? '#35087C' : 'transparent',
            }}
            item
            data-testid="side-menu-item-drivers"
            xs={12}
            className={
              collapsed
                ? classes.collapsed_active_menu_item
                : classes.active_menu_item
            }
          >
            <Link className={classes.linkSidebar} to={"/chauffeurs"}>
              <div className={classes.divCtn} style={{ padding: intl === 'ar' ? '18px 15px 16px 0px' : '18px 0px 16px 15px', width: collapsed ? 'auto' : '87%' }}>
                <FiUsers className={intl === 'ar' ? classes.iconLinkRight : classes.iconLink} />
                {!collapsed && <span className={intl === 'ar' ? classes.txtSidebarRight : classes.txtSidebar}>{t("drivers")}</span>}
              </div>
            </Link>
          </Grid>
          <div style={{ height: '10px' }} />
          <Grid
            onClick={() => { toggle(false); navigate('/vehicules') }}
            style={{
              padding: '30px 0px 30px 17px',
              backgroundColor: params?.type === 'vehicle' || window.location.pathname === '/vehicules' ? '#35087C' : 'transparent',
            }}
            item
            data-testid="side-menu-item-vehicls"
            xs={12}
            className={
              collapsed
                ? classes.collapsed_active_menu_item
                : classes.active_menu_item
            }
          >
            <Link className={classes.linkSidebar} to={"/vehicles"}>
              <div className={classes.divCtn} style={{ padding: intl === 'ar' ? '18px 15px 16px 0px' : '18px 0px 16px 15px', width: collapsed ? 'auto' : '87%' }}>
                <BiCar className={intl === 'ar' ? classes.iconLinkRight : classes.iconLink} />
                {!collapsed && <span className={intl === 'ar' ? classes.txtSidebarRight : classes.txtSidebar}>{t("vehicules")}</span>}
              </div>
            </Link>
          </Grid>
          <div style={{ height: '10px' }} />
          <Grid
            onClick={() => { }}
            style={{
              padding: '30px 0px 30px 17px',
              backgroundColor: collapsed && ['/paiements', '/revenues'].includes(window.location.pathname) ? '#35087C' : 'transparent'
            }}
            item
            data-testid="side-menu-item-accounts"
            xs={12}
            className={
              collapsed
                ? classes.collapsed_active_menu_item
                : classes.active_menu_item_special
            }
          >
            <div onClick={() => show ? toggle(false) : toggle(true)} className={classes.divCtn} style={{ padding: intl === 'ar' ? '18px 15px 16px 0px' : '18px 0px 16px 15px', width: collapsed ? 'auto' : '87%' }}>
              <BiWallet className={intl === 'ar' ? classes.iconLinkRight : classes.iconLink} />
              {!collapsed && <span className={intl === 'ar' ? classes.txtSidebarRight : classes.txtSidebar}>{t("accounts")}</span>}
              {!collapsed && <MdKeyboardArrowDown className={classes.flesh} style={
                intl === 'ar' ?
                  {
                    margin: '-5px 0px 0px 17px',
                    fontSize: '25px',
                    position: 'absolute',
                    left: 0,
                    transform: show ? 'rotate(180deg)' : 'rotate(0deg)',
                  } :
                  {
                    margin: '-5px 17px 0px 0px',
                    fontSize: '25px',
                    position: 'absolute',
                    right: 0,
                    transform: show ? 'rotate(180deg)' : 'rotate(0deg)',
                  }
              } />}
            </div>
          </Grid>
          {show &&
            <>
              <div style={{ height: '10px' }} />
              <Grid
                item
                data-testid="side-menu-item-payments"
                xs={12} md={12} lg={12}
                style={{
                  padding: '30px 0px 30px 17px',
                  backgroundColor: !collapsed && window.location.pathname.includes('/paiements') ? '#35087C' : 'transparent',
                }}
                className={
                  collapsed ? classes.collapsed_menu_item : classes.menu_item
                }
              >
                <Link className={classes.linkSidebar} to={"/paiements"}>
                  <div className={classes.divCtn} style={{ padding: intl === 'ar' ? '18px 15px 16px 0px' : '18px 0px 16px 15px', width: collapsed ? 'auto' : '87%' }}>
                    {!collapsed && <span className={intl === 'ar' ? classes.txtSidebarRight : classes.txtSidebar}>{t("payments")}</span>}
                  </div>
                </Link>
              </Grid>
              <div style={{ height: '10px' }} />
              <Grid
                item
                data-testid="side-menu-item-earnings"
                xs={12} md={12} lg={12}
                style={{
                  padding: '30px 0px 30px 17px',
                  backgroundColor: !collapsed && window.location.pathname === '/revenues' ? '#35087C' : 'transparent',
                }}
                className={
                  collapsed ? classes.collapsed_menu_item : classes.menu_item
                }
              >
                <Link className={classes.linkSidebar} to={"/revenues"}>
                  <div className={classes.divCtn} style={{ padding: intl === 'ar' ? '18px 15px 16px 0px' : '18px 0px 16px 15px', width: collapsed ? 'auto' : '87%' }}>
                    {!collapsed && <span className={intl === 'ar' ? classes.txtSidebarRight : classes.txtSidebar}>{t("earnings")}</span>}
                  </div>
                </Link>
              </Grid>
            </>}
          <div style={{ height: '10px' }} />
          <Grid
            item
            data-testid="side-menu-item-logout"
            xs={12} md={12} lg={12}
            style={{ cursor: "pointer" }}
            className={
              collapsed ? classes.collapsed_menu_item : classes.menu_item
            }
            onClick={() => {
              toggle(false);
              handleOpen();
            }}
          >
            <LogoutIcon
              sx={{
                color: "#FFF",
                height: "24px",
                width: "18px",
                transform: intl === 'ar' ? 'rotate(180deg)' : 'rotate(0deg)',
              }}
            />
            {!collapsed && <span className={intl === 'ar' ? classes.txtSidebarRight : classes.txtSidebar}>{t("logout")}</span>}
          </Grid>
        </Grid>
        <Grid
          data-testid="side-menu-collapse-button"
          item
          xs={12} sm={12} md={12} lg={12}
          className={
            collapsed
              ? classes.collapsed_menu_item_center
              : classes.menu_item_center
          }
          onClick={() => {
            if (window.innerWidth > 928) toggleMenu();
          }}
        >
          {collapsed ? (
            <KeyboardArrowRightIcon
              sx={{
                color: "#FFF",
                height: "24px",
                width: "18px",
              }}
            />
          ) : (
            <KeyboardArrowLeftIcon
              sx={{
                color: "#FFF",
                height: "24px",
                width: "18px",
              }}
            />
          )}
          {!collapsed && <span className={intl === 'ar' ? classes.txtSidebarRight : classes.txtSidebar}>{t("collapse")}</span>}
        </Grid>
      </Grid>
    </>
  );
};

export default memo(Sidebar);
